import { AppDispatch, PreQualificationStep, setPreQualificationStep } from 'prequalificationV2/actions';
import { applicationApi } from 'prequalificationV2/api/ApplicationApi';
import { getPostLoginNavigation } from 'prequalificationV2/pages/PreQualification/prequalification.utils';
import { AppRoutes } from 'prequalificationV2/routes/routes.enums';
import { checkBorrower } from 'prequalificationV2/utils/checkBorrower';
import { updateApplicationInStore } from 'prequalificationV2/utils/updateApplicationInStore';

export const navigateAfterLogin = async ({
  isLocked,
  dispatch,
  navigator,
}: {
  isLocked: boolean;
  dispatch: AppDispatch;
  navigator: (route: AppRoutes) => void;
}) => {
  const { borrowerApplication, hasCobborowerApplication } = await applicationApi.getActiveApplication();

  if (borrowerApplication) {
    updateApplicationInStore(borrowerApplication, dispatch);
  }

  if (isLocked && !borrowerApplication && !hasCobborowerApplication) {
    navigator(AppRoutes.Prequalification);
    dispatch(setPreQualificationStep(PreQualificationStep.NotAbleToAccept));

    return;
  }

  const navigation = await getPostLoginNavigation();

  checkBorrower({
    borrowerApplication: borrowerApplication,
    hasCobborowerApplication: hasCobborowerApplication,
    dispatch: dispatch,
    navigator: navigator,
    navigation: navigation,
  });
};
